import type { BrowseDataAPIFilterOption } from 'src/services/browse-data-api/types/BrowseDataAPIFilter';

export const getFilterOptionsWithoutNullActiveCounts = (options: BrowseDataAPIFilterOption[]) =>
  options.map((option) => ({ ...option, activeCount: null }));

export const getTitleFromFilterOptionUid = (filterOptionUid: string) => {
  const filterOptionTitle = filterOptionUid!.match(/filter\[(.*)\]/);
  return filterOptionTitle?.[1] ? filterOptionTitle[1].replace(/_/g, ' ') : filterOptionUid;
};
